import React from "react";

import { Box } from "../ui/chakra";
import { Flex } from "@chakra-ui/react";

const ReadonlyUserAlert = () => {
  return (
    <Flex
      py={3}
      bgColor="#B82100"
      color="white"
      justify="center"
      alignItems="center"
      gap={1}
      wrap="wrap"
    >
      <Box fontSize={{ base: "md", md: "lg" }} fontWeight="bold">
        閲覧専用ユーザーでログイン中
      </Box>
      <Box fontSize={{ base: "xs", md: "md" }}>
        （投稿などのアクションは行えません）
      </Box>
    </Flex>
  );
};

export default ReadonlyUserAlert;
